import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, TruckIcon, AwardIcon, CpuIcon } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  role: 'Tech Entrepreneur',
  text: 'I wore my Qtap smart t-shirt to a networking event and exchanged contacts with 30+ people just by letting them tap my shirt. Absolute game changer.',
  rating: 5
}, {
  name: 'Sarah K.',
  role: 'Content Creator',
  text: 'As a creator, this is the most innovative merch I have ever seen. My followers love tapping my smart t-shirt to see my latest hidden content.',
  rating: 5
}, {
  name: 'David R.',
  role: 'Soccer Fanatic',
  text: 'Ordered one for the World Cup. The fact that I can update what people see when they tap — stats, predictions, social links — is incredible.',
  rating: 5
}];
export function SocialProofSection() {
  return <section id="testimonials" className="py-10 md:py-20 bg-brand-dark relative" data-id="element-516">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-517">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-518">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-519">
            What People Are Saying
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold" data-id="element-520">
            The Future of Wearable Tech
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-521">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="glass-card p-8 flex flex-col" data-id="element-522">
              <div className="flex gap-1 mb-6" data-id="element-523">
                {[...Array(t.rating)].map((_, j) => <StarIcon key={j} className="w-5 h-5 fill-brand-cyan text-brand-cyan" data-id="element-524" />)}
              </div>
              <p className="text-gray-300 text-lg italic mb-8 flex-grow" data-id="element-525">
                "{t.text}"
              </p>
              <div data-id="element-526">
                <p className="font-bold text-white" data-id="element-527">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-528">{t.role}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Trust Badges */}

        {/* Press Logos Placeholder */}
        <div className="text-center" data-id="element-529"></div>
      </div>
    </section>;
}